import { AddBYOBundle } from "components/bundles/add-byo-button";
import Image from "next/image";
import puzzle from 'public/buildOwn/puzzle.png';
import { ShopifyRichText } from "utils/rich-text-converter";



export function BuildYourOwnCartItem({bundleHandle, shopifyProduct, redirectUrl }: {bundleHandle: any, shopifyProduct: any, redirectUrl: string}) {
    if(!bundleHandle || !shopifyProduct) return <div>No product details data, please connect to a Builder.io product details data model</div>
    const product = shopifyProduct.data
    const properties = bundleHandle.value.data.properties
    if(!properties) return null
    const summary = properties.find((property: any) => property.title === 'Summary')?.content
    return (
        <div className="w-full flex flex-col md:flex-row bg-white rounded-2xl border-none h-full">
            <div className="lg:w-[30%] h-full flex items-center justify-start">
                <Image 
                    src={product?.images[0]?.src || puzzle} 
                    alt={product?.title || "Build Your Own"} 
                    width={600} 
                    height={600} 
                    className="w-full h-auto rounded-t-2xl md:rounded-tr-none md:rounded-l-2xl"
                />
            </div>
            <div className="lg:w-[70%] flex flex-col p-4 lg:p-6 xl:p-8 item justify-center">
                <h2 className="text-[28px] text-fp-dark-gray font-bold text-center lg:text-left">
                    {product?.title}
                </h2>
                <div className="mt-4 font-light">
                    <div className="text-fp-darker-gray font-light text-[15px] text-center lg:text-left">
                        {summary ? (
                            <div dangerouslySetInnerHTML={{ __html: summary }} />
                        ) : (
                            <ShopifyRichText {...JSON.parse(product.descriptionHtml)} options={[]}/>
                        )}
                    </div>
                </div>
                
                <AddBYOBundle 
                    handle={product?.handle} 
                    redirect={'/shop/build-your-own/add-ons'}
                    classNames="w-fit font-base px-6 rounded-lg mx-auto lg:mx-0" 
                />
            </div>            
        </div>
    );
}